import * as R from 'ramda'

/*
Svg sprites are getting generated from https://svgsprite.com/tools/svg-sprite-generator/
 */

export const DEFAULT_BADGES_LIST = [
  {
    caption: 'Creative Gem',
    icon: 'star'
  },
  {
    caption: 'Goal Achieved',
    icon: 'sports-medal'
  },
  {
    caption: 'Great Going',
    icon: 'fire'
  },
  {
    caption: 'Milestone hit',
    icon: 'target-hit'
  },
  {
    caption: 'Full Marks',
    icon: 'full-marks'
  },
  {
    caption: 'Great Progress',
    icon: 'flag-post'
  },
  {
    caption: 'Well done',
    icon: 'clapping-hands'
  },
  {
    caption: 'Phenomenal Pace',
    icon: 'rocket'
  },
  {
    caption: 'Owned it',
    icon: 'trophy'
  },
  {
    caption: 'Milestone Achieved',
    icon: 'flag-in-hole'
  },
  {
    caption: 'Mountain Mover',
    icon: 'flexed-biceps'
  },
  {
    caption: 'Creative',
    icon: 'light-bulb'
  },
  {
    caption: 'Problem solved',
    icon: 'diamond-blue'
  },
  {
    caption: 'Amazing work',
    icon: 'thumbs-up'
  },
  {
    caption: 'Cheers',
    icon: 'beer-mugs'
  },
  {
    caption: 'Congrats',
    icon: 'clinking-glasses'
  },
  {
    caption: 'Hard work',
    icon: 'climb-wall'
  },
  {
    caption: 'Superb',
    icon: 'ok-hand'
  },
  {
    caption: 'Out of the Box',
    icon: 'vessel-blue'
  },
  {
    caption: 'Consistent',
    icon: 'diamond-yellow'
  }
]

export const BADGES_LIST = [
  {
    icon: 'star-ring'
  },
  {
    icon: 'person-lifting-weights'
  },
  {
    icon: 'car-3'
  },
  {
    icon: 'bomb'
  },
  {
    icon: 'fire-shine'
  },
  {
    icon: 'flash'
  },
  {
    icon: 'timer-clock'
  },
  {
    icon: 'money-bag'
  },
  {
    icon: 'horn'
  },
  {
    icon: 'siren'
  },
  {
    icon: 'shield'
  },
  {
    icon: 'auto-rickshaw'
  },
  {
    icon: 'mammoth'
  },
  {
    icon: 'superman'
  },
  {
    icon: 'superwomen'
  },
  {
    icon: 'brain'
  },
  {
    icon: 'compass'
  },
  {
    icon: 'eye'
  },
  {
    icon: 'flower'
  },
  {
    icon: 'apple'
  },
  {
    icon: 'chocolate'
  },
  {
    icon: 'ant'
  },
  {
    icon: 'pray'
  },
  {
    icon: 'top'
  },
  {
    icon: 'fist-bump'
  },
  {
    icon: 'yo-sign'
  },
  {
    icon: 'girls-wrestling'
  },
  {
    icon: 'slam-dunk'
  },
  {
    icon: 'karate'
  },
  {
    icon: 'fireworks'
  },
  {
    icon: 'medal'
  },
  {
    icon: 'celebrate'
  },
  {
    icon: 'crown'
  },
  {
    icon: 'spy'
  },
  {
    icon: 'peace-sign'
  },
  {
    icon: 'star-eyes'
  },
  {
    icon: 'whisky-glass'
  },
  {
    icon: 'goal'
  },
  {
    icon: 'medal-1'
  },
  {
    icon: 'medal-2'
  },
  {
    icon: 'medal-3'
  },
  {
    icon: 'ninja'
  },
  {
    icon: 'unicorn'
  },
  {
    icon: 'magic-wand'
  },
  {
    icon: 'coin'
  },
  {
    icon: 'weight-lift-2'
  },
  {
    icon: 'hammer'
  },
  {
    icon: 'dribble'
  },
  {
    icon: 'dribble-girl'
  },
  {
    icon: 'heart'
  },
  {
    icon: 'firecracker'
  },
  {
    icon: 'ufo'
  },
  {
    icon: 'candy'
  },
  {
    icon: 'telescope'
  },
  ...DEFAULT_BADGES_LIST.map(R.pick(['icon']))
]

export const REWARD_DEFAULT_BADGE = DEFAULT_BADGES_LIST.filter(b => b.icon === 'flag-post')[0]
